module.exports = __webpack_public_path__ + "static/img/icon5.9962c996.png";